const segmentedTabs = new WeakMap();

const initTabs = () => {
  initSegmentedTabs();

  const wrappers = document.querySelectorAll('.tab-wrapper:not(.binded)');
  if(wrappers){
    wrappers.forEach((wrapper) => {
      const tabs = wrapper.querySelectorAll('li[data-tab]');
      const contents = wrapper.querySelectorAll('[data-tab-content]');
      if(tabs && contents){
        tabs.forEach((tab) => {
          if(!tab.classList.contains('unavailable')){
            tab.addEventListener('click', () => {
              const activeTab = wrapper.querySelector('.active[data-tab]');
              if(activeTab){
                activeTab.classList.remove('active');
              }
              tab.classList.add('active');

              //Hide content of other tabs
              hideContents(contents);

              //Show content of tab clicked
              const currentContent = wrapper.querySelector("[data-tab-content='" + tab.dataset.tab + "']");
              currentContent.classList.remove('hidden');
            });
          }
        });
      }

      wrapper.classList.add('binded');
    });
  }
}

const initSegmentedTabs = () => {
  document.querySelectorAll('[data-segmented-tabs]').forEach((wrapper) => {
    if (segmentedTabs.has(wrapper)) return;

    const tabs = Array.from(wrapper.querySelectorAll('[data-segmented-tab]'))
      .filter(tab => tab.closest('[data-segmented-tabs]') === wrapper);
    const panels = Array.from(wrapper.querySelectorAll('[data-segmented-panel]'))
      .filter(panel => panel.closest('[data-segmented-tabs]') === wrapper);

    const getPanelId = tab => tab.dataset.segmentedTab || tab.getAttribute('aria-controls');

    const selectTab = (selectedTab, userInitiated = false) => {
      if (!selectedTab || selectedTab.disabled || selectedTab.getAttribute('aria-disabled') === 'true') return;

      const changed = !selectedTab.classList.contains('segmented-tabs-item--active');
      const panelId = getPanelId(selectedTab);

      tabs.forEach((tab) => {
        const active = tab === selectedTab;
        tab.classList.toggle('segmented-tabs-item--active', active);
        if (tab.hasAttribute('aria-selected')) {
          tab.setAttribute('aria-selected', String(active));
        }
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.classList.toggle('hidden', panel.id !== panelId);
      });

      wrapper.dispatchEvent(new CustomEvent('segmented-tabs:select', {
        bubbles: true,
        detail: { panelId, userInitiated }
      }));

      if (changed) {
        wrapper.dispatchEvent(new CustomEvent('segmented-tabs:change', {
          bubbles: true,
          detail: { panelId }
        }));
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        selectTab(tab, true);
      });
      tab.addEventListener('keydown', (event) => {
        const enabledTabs = tabs.filter(item => !item.disabled && item.getAttribute('aria-disabled') !== 'true');
        const index = enabledTabs.indexOf(tab);
        if (index === -1) return;

        const direction = { ArrowLeft: -1, ArrowRight: 1 }[event.key];
        let nextIndex;
        if (direction) {
          nextIndex = (index + direction + enabledTabs.length) % enabledTabs.length;
        } else if (event.key === 'Home' || event.key === 'End') {
          nextIndex = event.key === 'Home' ? 0 : enabledTabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        selectTab(enabledTabs[nextIndex], true);
        enabledTabs[nextIndex].focus();
      });
    });

    wrapper.addEventListener('invalid', (event) => {
      const panel = event.target.closest('[data-segmented-panel]');
      const tab = panel && tabs.find(item => getPanelId(item) === panel.id);
      if (tab) selectTab(tab);
    }, true);

    segmentedTabs.set(wrapper, panelId => selectTab(tabs.find(tab => getPanelId(tab) === panelId)));
  });
};

const hideContents = (contents) => {
  contents.forEach((content) => {
    content.classList.add('hidden');
  });
}

const selectSegmentedTab = (wrapper, panelId) => {
  const select = segmentedTabs.get(wrapper);
  if (select) select(panelId);
};

export { initTabs, selectSegmentedTab }
